module.exports = __webpack_public_path__ + "img/African_Bank_Logo.ee92a4a8.svg";